module.exports = library_MicroFrame;